// src/firebase.js
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBelr-jMpWr1jF20fzRGTNLq6qas5_sgtE",
  authDomain: "memo-track.firebaseapp.com",
  projectId: "memo-track",
  storageBucket: "memo-track.firebasestorage.app",
  messagingSenderId: "715157154250",
  appId: "1:715157154250:web:d22b5b79eb91a358928733",
  measurementId: "G-SS779ZYXC3"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {
  console.warn("Firebase Messaging error:", e);
}

export const analytics = getAnalytics(app);

// Helper to lazily load ApiService to prevent module circular dependency
const getApiService = () => {
  try {
    const ApiService = require("../services/api").default;
    return new ApiService();
  } catch (e) {
    console.error("ApiService error:", e);
    return null;
  }
};

/**
 * Get or generate FCM token
 */
export const getOrGenerateFcmToken = async () => {
  if (!messaging) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    const token = await getToken(messaging, {
      vapidKey: "BKQj51TqtH-h-COq1-R8QUvVNQHp3PSy6VZ6QVJne2qsnobkai2-nXejbNkn0dO6CGkZF3WHsQSu0D2qU_H31-s",
    });

    if (!token) return null;

    const oldToken = localStorage.getItem("fcm_token");
    if (oldToken !== token) {
      localStorage.setItem("fcm_token", token);
    }
    return token;
  } catch (err) {
    console.error("Error retrieving FCM token:", err);
    return null;
  }
};

/**
 * Foreground listener
 */
if (messaging) {
  onMessage(messaging, (payload) => {
    const title = payload.data?.title || payload.notification?.title || "New Notification";
    const body = payload.data?.body || payload.notification?.body || "";
    const icon = payload.data?.icon || payload.notification?.icon || "/logo192.png";
    const messageId = payload.messageId || payload.data?.message_id || payload.fcmMessageId;
    const tenantSlug = payload.data?.tenant_slug;

    if (messageId) {
      const apiService = getApiService();
      if (apiService) {
        apiService.updateNotificationStatus(messageId, 'DELIVERED', 'WEB', tenantSlug);
      }
    }

    if (Notification.permission === "granted") {
      const notification = new Notification(title, {
        body,
        icon,
        tag: messageId || 'memotrack-notification',
        data: payload.data || {}
      });

      notification.onclick = (event) => {
        event.preventDefault();
        notification.close();
        if (typeof window !== 'undefined' && window.focus) {
          window.focus();
        }

        if (messageId) {
          const apiService = getApiService();
          if (apiService) {
            apiService.updateNotificationStatus(messageId, 'OPENED', 'WEB', tenantSlug);
          }
        }

        const memoId = payload.data?.memo_id || payload.notification?.memo_id;
        if (memoId) {
          window.location.href = `/memo/${memoId}`;
        }
      };
    }
  });
}
